<template>
  <v-card class="pa-4 px-6" flat>
    <div class="d-flex align-center">
      <h3>Remessas</h3>
      <v-spacer></v-spacer>
      <v-btn icon @click="excel">
        <v-icon>mdi-download</v-icon>
      </v-btn>
    </div>

    <v-divider class="ma-2"></v-divider>

    <v-data-table
        :items="items"
        :loading="loading"
        :headers="headers"
        class="content-table"
        style="cursor: pointer"
        hide-default-footer
        loading-text="Buscando..."
        no-data-text="Sem registros"
    >
      <template v-slot:[`item.order`]="{ item }">
        {{(item.order.totalPrice + item.order.fretePrice + item.order.installmentsInterest).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })}}
      </template>

      <template v-slot:[`item.orderStatus`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                outlined
                style="border-radius: 12px"
                :class="
                      item.order.orderStatus === 0
                        ? 'novo'
                        : item.order.orderStatus === 1
                        ? 'aguardando'
                        : item.order.orderStatus === 3 ||
                          item.order.orderStatus === 6 ||
                          item.order.orderStatus === 10
                        ? 'enviado'
                        : item.order.orderStatus === 4 || item.orderStatus === 9
                        ? 'enviado'
                        : item.order.orderStatus === 7 ||
                          item.order.orderStatus === 5 ||
                          item.order.orderStatus === 2 ||
                          item.order.orderStatus === 11
                        ? 'devolvido'
                        : 'entregue'
                    "
                v-bind="attrs"
                v-on="on"
            >
              <v-icon style="font-size: 15px"
              >{{
                  status1.find((x) => x.value === item.order.orderStatus).label
                }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{
              status1.find((x) => x.value === item.order.orderStatus).label
            }}</span>
        </v-tooltip>
      </template>

      <template
          v-slot:[`item.actions`]="{ item }"
          cols="12"
          md="6"
          xs="12"
          sm="12"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                outlined
                fab
                tile
                :disabled="item.done"
                small
                class="edit-button"
                @click="orderDetail(item, $event)"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon color="#e30011" dark>mdi-eye-outline</v-icon>
            </v-btn>
          </template>
          <span>Ver pedido</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
              <span :class="item.order.orderStatus == 0 ? 'novo-bold' : 'normal'">
                {{ formatDate(item.order.created_at) }}
              </span>
      </template>
      <template v-slot:[`item.frete`]="{ item }">
        {{item.frete ? 'Sim' : 'Não'}}
      </template>

      <template v-slot:[`item.commission`]="{ item }">
        {{(item.commission).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })}}
      </template>
      <template v-slot:[`item.discount`]="{ item }">
        {{(item.order.discount).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })}}
      </template>

      <template v-slot:[`item.totalVendedor`]="{ item }">
        {{
          (((item.order.totalPrice + item.order.fretePrice + item.order.installmentsInterest) - (item.commission  + item.order.fees + item.order.items.filter(x => x.refundDate).reduce((acumulador, produto) => acumulador + (produto.price * produto.qty), 0)))).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })}}
      </template>

      <template v-slot:[`item.refund`]="{ item }">
        {{
          (item.order.items.filter(x => x.refundDate).reduce((acumulador, produto) => acumulador + (produto.price * produto.qty), 0)).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })}}
      </template>

      <template v-slot:[`item.fees`]="{ item }">
        {{item.order.fees.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })}}
      </template>
      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="pageCount"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Utils from "../../../../Utils/FormatDate";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "Shipments",
  components: {
    Pagination,
  },
  props: {
    filter: Object,
  },

  async created() {
    await this.list();
  },

  data() {
    return {
      pageCount: 1,
      resaleproductsku: null,
      items: [],
      resales: [],
      products: [],
      resaleSelected: [],
      productsSelected: [],
      loading: false,
      dialogSendForResale: false,
      dialogSendForProduct: false,
      searchCategoryInput: '',
      dialog: false,
      apiService: new ApiService(),
      status1: [
        { label: "Aguardando", value: 1 },
        { label: "Reprovado", value: 2 },
        { label: "Aprovado", value: 3 },
        { label: "Separando", value: 6 },
        { label: "Etiqueta", value: 10 },
        { label: "Enviado", value: 4 },
        { label: "Entregue", value: 8 },
        { label: "Cancelado", value: 7 },
        { label: "Retirar", value: 9 },
        { label: "Devolvido", value: 5 },
        { label: "Reprovado", value: 2 },
        { label: "Entregue", value: 8 },
        { label: "Devolvido", value: 5 },
        { label: "Cancelado", value: 7 },
        { label: "Cancelado parcialmente", value: 11 },
      ],
      headers: [
        {
          text: "Pedido Id",
          align: "center",
          sortable: false,
          value: "order.id",
        },
        {
          text: "Remessa Id",
          align: "center",
          sortable: false,
          value: "id",
        },
        {
          text: "Total",
          align: "center",
          sortable: false,
          value: "order",
        },
        {
          text: "Cobrado de",
          align: "center",
          sortable: false,
          value: "user.name",
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "orderStatus",
        },
        {
          text: "Data do Pedido",
          align: "center",
          sortable: false,
          value: "created_at",
        },
        {
          text: "Nome do Vendedor",
          align: "center",
          sortable: false,
          value: "order.resale.nameFantasy",
        },
        {
          text: "Frete Grátis",
          align: "center",
          sortable: false,
          value: "frete",
        },
        {
          text: "Comissão",
          align: "center",
          sortable: false,
          value: "commission",
        },
        {
          text: "Desconto",
          align: "center",
          sortable: false,
          value: "discount",
        },
        {
          text: "Taxas",
          align: "center",
          sortable: false,
          value: "fees",
        },
        {
          text: "Reembolso parcial",
          align: "center",
          sortable: false,
          value: "refund",
        },
        {
          text: "Total Vendedor",
          align: "center",
          sortable: false,
          value: "totalVendedor",
        },

        {
          text: "Ações",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      pageSize: 10,
      currentPage: 10,
      totalItems: 10,
      page: 1,
      resale: 1,
      product: 2,
      minimumStockcs: {
        resaleIds: [],
        productSkuIds: [],
        notifyBy: 1
      },
    };
  },
  computed: {

  },
  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },
    async list() {
      try {
        this.loading = true;
        this.apiService
            .post(
                "dashboard/shipments",
                {...this.filter, page: this.page},
                false,
            )
            .then((response) => {
              console.log('response.content.data')
              console.log(response.content.data)
              console.log('response.content.data')
              this.items = response.content.data;
              this.pageCount = response.content.pager.totalPages;
              this.totalItems = response.content.pager.totalItems;
              this.currentPage = response.content.pager.currentPage;

              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
      } catch (e) {
      }
    },

    async backPage() {
      this.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.page += 1;
      await this.list();
    },

    excel() {
      this.loading = true;

      this.apiService
          .post(
              "dashexport/shipments",
              { ...this.filter, page: this.page },
              false,
              false,
              true
          )
          .then((response) => {
            const excel =
                "data:application/octet-stream;base64," + response.content;
            const link = document.createElement("a");
            link.href = excel;
            link.setAttribute("download", `remessas.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },

    async orderDetail(item) {
      await this.$router.push({
        path: `/order-detail?id=` + item.order.id,
        params: item,
      });
    },

    notify() {
      try {
        this.dialog = false
        this.apiService.post("resaleproductsku/notify-resale", this.resaleproductsku, false, false, true)
            .then((response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: response.message ? response.message : "Revenda notificada",
                trace: null,
              });
              this.list()
            })
            .catch(() => {
              this.loading = false;
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível notificar revenda",
                trace: null,
              });
            });
      } catch (e) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Não foi possível marcar o pedido de reembolso como concluído.",
          trace: null,
        });
      }
    },

    notifyResales() {
      try {
        if(this.minimumStockcs.notifyBy === this.resale){
          this.minimumStockcs.resaleIds = this.resaleSelected.map((x) => x.id)
        } else {
          this.minimumStockcs.productSkuIds = this.productsSelected.map((x) => x.id)
        }
        this.dialogSendForResale = false
        this.dialogSendForProduct = false
        this.apiService.post("resaleproductsku/notify-resales", this.minimumStockcs, false, false, true)
            .then((response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: response.message ? response.message : "Revendas notificadas",
                trace: null,
              });
              this.list()
            })
            .catch((error) => {
              this.loading = false;
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível notificar revendas",
                trace: null,
              });
            });
      } catch (e) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Não foi possível marcar o pedido de reembolso como concluído.",
          trace: null,
        });
      }
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.list();
      },
    },
  },
};
</script>

<style>
.aguardando {
  width: max-content !important;
  height: 30px !important;
  color: orange !important;
  border: 1px solid orange !important;
  box-sizing: border-box !important;
  border-radius: 7px !important;
}

.aprovado {
  height: 30px !important;
  color: #fee853 !important;
  border: 1px solid #fee853;
  box-sizing: border-box !important;
  border-radius: 7px !important;
  font-style: normal !important;
  font-weight: 300 !important;
  font-size: 3px !important;
}

.entregue {
  height: 30px !important;
  color: #8dc63f !important;
  border: 1px solid #8dc63f !important;
  box-sizing: border-box !important;
}

.enviado {
  height: 30px !important;
  color: #8dc63f !important;
  border: 1px solid #8dc63f !important;
  box-sizing: border-box !important;
  border-radius: 7px !important;
}

.devolvido {
  height: 30px !important;
  color: #e30011 !important;
  border: 1px solid #e30011 !important;
  box-sizing: border-box !important;
  border-radius: 7px !important;
}

.cancelado {
  height: 30px !important;
  color: #e30011 !important;
  border: 1px solid #e30011 !important;
  box-sizing: border-box !important;
  border-radius: 7px !important;
}

.edit-button {
  margin-top: -5px !important;
  border: 1px solid #e30011 !important;
  border-radius: 4px;
  width: 35px !important;
  height: 30px !important;
}
</style>
